import React, { Fragment } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { FormControlLabel, Grid, FormControl, Radio, RadioGroup, Typography, FormGroup, FormLabel } from "@material-ui/core";
import CustomCheckbox from "../CustomCheckbox";
import translate from '../../other/translate.json';

export default function FilterInterface(props) {
  const classes = useStyles();
  const language = localStorage.getItem('language') || 'Ru';
  const [value, setValue] = React.useState(null);

  return (
    <React.Fragment>
      <FormControl component="fieldset">
        <FormLabel component="legend" focused={false} className={classes.header}>{translate.Words[`Interface${language}`]}:</FormLabel>

        <FormGroup>
          <FormControlLabel
            control={<CustomCheckbox checked={props.nav === '1'} onChange={() => { props.nav === '1' ? props._nav('0') : props._nav('1') }} />}
            label={translate.Words[`Navigator${language}`]}
            className={classes.FClabel}
          />

          <FormControlLabel
            control={<CustomCheckbox checked={props.web === '1'} onChange={() => { props.web === '1' ? props._web('0') : props._web('1') }} />}
            label={translate.Words[`WebBrowser${language}`]}
            className={classes.FClabel}
          />

          {/* <FormControlLabel
            control={<Checkbox checked={antoine} onChange={handleChange} name="antoine" />}
            label="Antoine Llorca"
          /> */}
        </FormGroup>
      </FormControl>
    </React.Fragment>
  )
}

const useStyles = makeStyles(theme => ({
  header: {
    marginTop: 20,
    marginBottom: 10,
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '28px',
    color: '#24262A'
  },

  FClabel: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    lineHeight: '24px',
    color: '#8987A2'
  }
}))